module.exports = function() {
  return new Worker(__webpack_public_path__ + "95919db51eb380f8216b.worker.js");
};